import {
  RiAlarmWarningLine,
  RiCloseCircleLine,
  RiLockLine,
  RiTimerFlashLine,
} from "@remixicon/react";

import { useTranslate } from "@tolgee/react";
import { type ReactNode } from "react";

export type States = "expired" | "maintenance" | "401" | "403" | "404" | "500";

interface StateProps {
  title: string;
  description: string;
  icon: ReactNode;
  button?: {
    label: string;
    link: string;
  };
}

// Returns associated props with a given state for a specific page.
export const useStatesProps = (state: States): StateProps => {
  const { t } = useTranslate();

  switch (state) {
    case "expired":
      return {
        title: t("templateKazaarPage.expired.title"),
        description: t("templateKazaarPage.expired.description"),
        icon: <RiTimerFlashLine className="h-16 w-16 text-warning-main" />,
        button: {
          label: t("templateKazaarPage.expired.buttonLabel"),
          link: "/",
        },
      };
    case "maintenance":
      return {
        title: t("templateKazaarPage.maintenance.title"),
        description: t("templateKazaarPage.maintenance.description"),
        icon: <RiTimerFlashLine className="h-16 w-16 text-text-bodyvariant" />,
      };
    // Errors states
    case "401":
      return {
        title: t("templateKazaarPage.error.401.title"),
        description: t("templateKazaarPage.error.401.description"),
        icon: <RiLockLine className="h-16 w-16 text-warning-main" />,
        button: {
          label: t("templateKazaarPage.error.401.buttonLabel"),
          link: "/",
        },
      };
    case "403":
      return {
        title: t("templateKazaarPage.error.403.title"),
        description: t("templateKazaarPage.error.403.description"),
        icon: <RiLockLine className="h-16 w-16 text-warning-main" />,
        button: {
          label: t("templateKazaarPage.error.403.buttonLabel"),
          link: "/",
        },
      };
    case "500":
      return {
        title: t("templateKazaarPage.error.500.title"),
        description: t("templateKazaarPage.error.500.description"),
        icon: <RiAlarmWarningLine className="h-16 w-16 text-error-text" />,
        button: {
          label: t("templateKazaarPage.error.500.buttonLabel"),
          link: "/",
        },
      };
    default:
      return {
        title: t("templateKazaarPage.error.404.title"),
        description: t("templateKazaarPage.error.404.description"),
        icon: <RiCloseCircleLine className="h-16 w-16 text-error-text" />,
        button: {
          label: t("templateKazaarPage.error.404.buttonLabel"),
          link: "/",
        },
      };
  }
};
